const currentLoading = {};

(function($) {
  $.loading = $.fn.loading = function(type) {
    if (type === 'reset') {
      return reset($(this));
    }

    if (type === 'reset-all') {
      return resetAll();
    }

    loading($(this));
  }
}(jQuery));

function reset(el) {
  if (!el) return;

  el.removeClass('disabled');
  el.removeClass('loading');
  el.prop('disabled', false);

  currentLoading[el.attr('id')] = el;

  NProgress.done();
}

function resetAll() {
  Object.keys(currentLoading).forEach((id) => {
    reset($(`#${id}`));
  });
}

function loading(el) {
  if (!el) return;

  let elId = el.attr( 'id' );

  if (!elId) {
    elId = 'loading-id-' + Math.random().toString( 16 ).slice( 2, 10 );
    el.attr('id', elId);
  }

  el.addClass('disabled');
  el.addClass('loading');
  el.prop('disabled', true);

  currentLoading[elId] = el;

  NProgress.start();
}
